import { render, staticRenderFns } from "./drawpigresi.vue?vue&type=template&id=5d155bb6&scoped=true&"
import script from "./drawpigresi.vue?vue&type=script&lang=js&"
export * from "./drawpigresi.vue?vue&type=script&lang=js&"
import style0 from "./drawpigresi.vue?vue&type=style&index=0&id=5d155bb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d155bb6",
  null
  
)

export default component.exports